import ArchiveSvg from '@fukuri-admins/assets/icons/archive.svg?react';
import AwardSvg from '@fukuri-admins/assets/icons/award.svg?react';
import BabySvg from '@fukuri-admins/assets/icons/baby.svg?react';
import BellSvg from '@fukuri-admins/assets/icons/bell.svg?react';
import BicepsFlexedSvg from '@fukuri-admins/assets/icons/biceps-flexed.svg?react';
import BookImageSvg from '@fukuri-admins/assets/icons/book-image.svg?react';
import BookMarkedSvg from '@fukuri-admins/assets/icons/book-marked.svg?react';
import BookOpenSvg from '@fukuri-admins/assets/icons/book-open.svg?react';
import BuildingSvg from '@fukuri-admins/assets/icons/building.svg?react';
import BusSvg from '@fukuri-admins/assets/icons/bus.svg?react';
import CakeSvg from '@fukuri-admins/assets/icons/cake.svg?react';
import CalculatorSvg from '@fukuri-admins/assets/icons/calculator.svg?react';
import CalendarSvg from '@fukuri-admins/assets/icons/calendar.svg?react';
import CalendarClockSvg from '@fukuri-admins/assets/icons/calendar-clock.svg?react';
import CarSvg from '@fukuri-admins/assets/icons/car.svg?react';
import ChartLineSvg from '@fukuri-admins/assets/icons/chart-line.svg?react';
import CheckSvg from '@fukuri-admins/assets/icons/check.svg?react';
import ChevronDownSvg from '@fukuri-admins/assets/icons/chevron-down.svg?react';
import ChevronLeftSvg from '@fukuri-admins/assets/icons/chevron-left.svg?react';
import ChevronRightSvg from '@fukuri-admins/assets/icons/chevron-right.svg?react';
import ChevronUpSvg from '@fukuri-admins/assets/icons/chevron-up.svg?react';
import ChevronsLeftSvg from '@fukuri-admins/assets/icons/chevrons-left.svg?react';
import ChevronsRightSvg from '@fukuri-admins/assets/icons/chevrons-right.svg?react';
import ChevronsUpDownSvg from '@fukuri-admins/assets/icons/chevrons-up-down.svg?react';
import CircleAlertSvg from '@fukuri-admins/assets/icons/circle-alert.svg?react';
import CircleCheckSvg from '@fukuri-admins/assets/icons/circle-check.svg?react';
import CircleCrossSvg from '@fukuri-admins/assets/icons/circle-cross.svg?react';
import CirclePlusSvg from '@fukuri-admins/assets/icons/circle-plus.svg?react';
import CircleQuestionSvg from '@fukuri-admins/assets/icons/circle-question.svg?react';
import ClockSvg from '@fukuri-admins/assets/icons/clock.svg?react';
import CoffeeSvg from '@fukuri-admins/assets/icons/coffee.svg?react';
import CopySvg from '@fukuri-admins/assets/icons/copy.svg?react';
import CreditCardSvg from '@fukuri-admins/assets/icons/credit-card.svg?react';
import CrossSvg from '@fukuri-admins/assets/icons/cross.svg?react';
import CupSodaSvg from '@fukuri-admins/assets/icons/cup-soda.svg?react';
import DatabaseSvg from '@fukuri-admins/assets/icons/database.svg?react';
import DownloadSvg from '@fukuri-admins/assets/icons/download.svg?react';
import EllipsisSvg from '@fukuri-admins/assets/icons/ellipsis.svg?react';
import EllipsisVerticalSvg from '@fukuri-admins/assets/icons/ellipsis-vertical.svg?react';
import ExternalLinkSvg from '@fukuri-admins/assets/icons/external-link.svg?react';
import FactorySvg from '@fukuri-admins/assets/icons/factory.svg?react';
import FileSvg from '@fukuri-admins/assets/icons/file.svg?react';
import FileDownSvg from '@fukuri-admins/assets/icons/file-down.svg?react';
import FileTextSvg from '@fukuri-admins/assets/icons/file-text.svg?react';
import FilmSvg from '@fukuri-admins/assets/icons/film.svg?react';
import GiftSvg from '@fukuri-admins/assets/icons/gift.svg?react';
import GlobeSvg from '@fukuri-admins/assets/icons/globe.svg?react';
import GraduationCapSvg from '@fukuri-admins/assets/icons/graduation-cap.svg?react';
import GripVerticalSvg from '@fukuri-admins/assets/icons/grip-vertical.svg?react';
import HandCoinsSvg from '@fukuri-admins/assets/icons/hand-coins.svg?react';
import HandshakeSvg from '@fukuri-admins/assets/icons/handshake.svg?react';
import HeartSvg from '@fukuri-admins/assets/icons/heart.svg?react';
import HospitalSvg from '@fukuri-admins/assets/icons/hospital.svg?react';
import HouseSvg from '@fukuri-admins/assets/icons/house.svg?react';
import InfoSvg from '@fukuri-admins/assets/icons/info.svg?react';
import LaptopSvg from '@fukuri-admins/assets/icons/laptop.svg?react';
import LayoutDashboardSvg from '@fukuri-admins/assets/icons/layout-dashboard.svg?react';
import LinkSvg from '@fukuri-admins/assets/icons/link.svg?react';
import ListChecksSvg from '@fukuri-admins/assets/icons/list-checks.svg?react';
import MailSvg from '@fukuri-admins/assets/icons/mail.svg?react';
import MailPlusSvg from '@fukuri-admins/assets/icons/mail-plus.svg?react';
import MegaphoneSvg from '@fukuri-admins/assets/icons/megaphone.svg?react';
import MinusSvg from '@fukuri-admins/assets/icons/minus.svg?react';
import MusicSvg from '@fukuri-admins/assets/icons/music.svg?react';
import NewspaperSvg from '@fukuri-admins/assets/icons/newspaper.svg?react';
import NotepadTextSvg from '@fukuri-admins/assets/icons/notepad-text.svg?react';
import PiggyBankSvg from '@fukuri-admins/assets/icons/piggy-bank.svg?react';
import PlusSvg from '@fukuri-admins/assets/icons/plus.svg?react';
import RotateCcwSvg from '@fukuri-admins/assets/icons/rotate-ccw.svg?react';
import SearchSvg from '@fukuri-admins/assets/icons/search.svg?react';
import SendSvg from '@fukuri-admins/assets/icons/send.svg?react';
import StarSvg from '@fukuri-admins/assets/icons/star.svg?react';
import StoreSvg from '@fukuri-admins/assets/icons/store.svg?react';
import TicketSvg from '@fukuri-admins/assets/icons/ticket.svg?react';
import TrashSvg from '@fukuri-admins/assets/icons/trash.svg?react';
import TreePalmSvg from '@fukuri-admins/assets/icons/tree-palm.svg?react';
import TrophySvg from '@fukuri-admins/assets/icons/trophy.svg?react';
import TruckSvg from '@fukuri-admins/assets/icons/truck.svg?react';
import UserSvg from '@fukuri-admins/assets/icons/user.svg?react';
import UtensilsSvg from '@fukuri-admins/assets/icons/utensils.svg?react';
import { createSvgIcon } from './BaseIcon';

/**
 * import の `?react` は vite-plugin-svgr のクエリサフィックス。
 * 通常の SVG import は URL 文字列を返すが、`?react` を付けると
 * ビルド時に SVG ファイルが React コンポーネント（SVGProps を受け取る FC）へ変換される。
 * ランタイムでの fetch は発生しない。
 *
 * import 変数を大文字始まりにしているのは React コンポーネントの命名慣習に合わせるため。
 * `createSvgIcon` の引数として渡すだけなので動作上は小文字でも問題ないが、
 * 「これは React コンポーネントである」という意図を示すために大文字にしている。
 */
export const ArchiveIcon = createSvgIcon(ArchiveSvg);
export const AwardIcon = createSvgIcon(AwardSvg);
export const BabyIcon = createSvgIcon(BabySvg);
export const BellIcon = createSvgIcon(BellSvg);
export const BicepsFlexedIcon = createSvgIcon(BicepsFlexedSvg);
export const BookImageIcon = createSvgIcon(BookImageSvg);
export const BookMarkedIcon = createSvgIcon(BookMarkedSvg);
export const BookOpenIcon = createSvgIcon(BookOpenSvg);
export const BuildingIcon = createSvgIcon(BuildingSvg);
export const BusIcon = createSvgIcon(BusSvg);
export const CakeIcon = createSvgIcon(CakeSvg);
export const CalculatorIcon = createSvgIcon(CalculatorSvg);
export const CalendarClockIcon = createSvgIcon(CalendarClockSvg);
export const CalendarIcon = createSvgIcon(CalendarSvg);
export const CarIcon = createSvgIcon(CarSvg);
export const ChartLineIcon = createSvgIcon(ChartLineSvg);
export const CheckCircleIcon = createSvgIcon(CircleCheckSvg);
export const CheckIcon = createSvgIcon(CheckSvg);
export const ChevronDownIcon = createSvgIcon(ChevronDownSvg);
export const ChevronLeftIcon = createSvgIcon(ChevronLeftSvg);
export const ChevronRightIcon = createSvgIcon(ChevronRightSvg);
export const ChevronUpIcon = createSvgIcon(ChevronUpSvg);
export const ChevronsLeftIcon = createSvgIcon(ChevronsLeftSvg);
export const ChevronsRightIcon = createSvgIcon(ChevronsRightSvg);
export const ChevronsUpDownIcon = createSvgIcon(ChevronsUpDownSvg);
export const CircleAlertIcon = createSvgIcon(CircleAlertSvg);
export const CirclePlusIcon = createSvgIcon(CirclePlusSvg);
export const CircleQuestionIcon = createSvgIcon(CircleQuestionSvg);
export const CircleCrossIcon = createSvgIcon(CircleCrossSvg);
export const ClockIcon = createSvgIcon(ClockSvg);
export const CoffeeIcon = createSvgIcon(CoffeeSvg);
export const CopyIcon = createSvgIcon(CopySvg);
export const CreditCardIcon = createSvgIcon(CreditCardSvg);
export const CrossIcon = createSvgIcon(CrossSvg);
export const CupSodaIcon = createSvgIcon(CupSodaSvg);
export const DatabaseIcon = createSvgIcon(DatabaseSvg);
export const DownloadIcon = createSvgIcon(DownloadSvg);
export const EllipsisIcon = createSvgIcon(EllipsisSvg);
export const EllipsisVerticalIcon = createSvgIcon(EllipsisVerticalSvg);
export const ExternalLinkIcon = createSvgIcon(ExternalLinkSvg);
export const FactoryIcon = createSvgIcon(FactorySvg);
export const FileDownloadIcon = createSvgIcon(FileDownSvg);
export const FileIcon = createSvgIcon(FileSvg);
export const FileTextIcon = createSvgIcon(FileTextSvg);
export const FilmIcon = createSvgIcon(FilmSvg);
export const GiftIcon = createSvgIcon(GiftSvg);
export const GlobeIcon = createSvgIcon(GlobeSvg);
export const GraduationCapIcon = createSvgIcon(GraduationCapSvg);
export const GripVerticalIcon = createSvgIcon(GripVerticalSvg);
export const HandCoinsIcon = createSvgIcon(HandCoinsSvg);
export const HandshakeIcon = createSvgIcon(HandshakeSvg);
export const HeartIcon = createSvgIcon(HeartSvg);
export const HospitalIcon = createSvgIcon(HospitalSvg);
export const HouseIcon = createSvgIcon(HouseSvg);
export const InfoIcon = createSvgIcon(InfoSvg);
export const LaptopIcon = createSvgIcon(LaptopSvg);
export const LayoutDashboardIcon = createSvgIcon(LayoutDashboardSvg);
export const LinkIcon = createSvgIcon(LinkSvg);
export const ListChecksIcon = createSvgIcon(ListChecksSvg);
export const MailIcon = createSvgIcon(MailSvg);
export const MailPlusIcon = createSvgIcon(MailPlusSvg);
export const MegaphoneIcon = createSvgIcon(MegaphoneSvg);
export const MinusIcon = createSvgIcon(MinusSvg);
export const MusicIcon = createSvgIcon(MusicSvg);
export const NewspaperIcon = createSvgIcon(NewspaperSvg);
export const NotepadTextIcon = createSvgIcon(NotepadTextSvg);
export const PiggyBankIcon = createSvgIcon(PiggyBankSvg);
export const PlusIcon = createSvgIcon(PlusSvg);
export const RotateCcwIcon = createSvgIcon(RotateCcwSvg);
export const SearchIcon = createSvgIcon(SearchSvg);
export const SendIcon = createSvgIcon(SendSvg);
export const StarIcon = createSvgIcon(StarSvg);
export const StoreIcon = createSvgIcon(StoreSvg);
export const TicketIcon = createSvgIcon(TicketSvg);
export const TrashIcon = createSvgIcon(TrashSvg);
export const TreePalmIcon = createSvgIcon(TreePalmSvg);
export const TrophyIcon = createSvgIcon(TrophySvg);
export const TruckIcon = createSvgIcon(TruckSvg);
export const UserIcon = createSvgIcon(UserSvg);
export const UtensilsIcon = createSvgIcon(UtensilsSvg);
